//slickを動かすためのjsです

$(document).ready(function () {
  $(".slick-slider")
    // 最初のスライドに"add-animation"のclassを付ける(data-slick-index="0"が最初のスライドを指す)
    .on("init", function () {
      $('.slick-slide[data-slick-index="0"]').find('.slick-img').addClass("add-animation");
    })
    // 通常のオプション
    .slick({
      fade: true,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: 3000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      dotsClass: 'slick-slider-dots',
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    })
    .on({
      // スライドが移動する前に発生するイベント
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        // 表示されているスライドに"add-animation"のclassをつける
        $(".slick-img", this).eq(nextSlide).addClass("add-animation");
        // 表示されているスライドに"remove-animation"のclassを付ける
        $(".slick-img", this).eq(currentSlide).addClass("remove-animation");
      },
      // スライドが移動した後に発生するイベント
      afterChange: function () {
        // 表示していないスライドはアニメーションのclassを外す
        $(".remove-animation", this).removeClass("remove-animation add-animation");
      },
    });
});


$(function(){//スライダーの枚数に応じてプログレスバーの幅を決める
  const dotsList = $('.slick-slider-dots');
  const numberOfItems = dotsList.children().length;
  const widthPercentage = 100 / numberOfItems;

  // Set the width of each li element based on the calculated width percentage
  dotsList.children().css('width', widthPercentage + '%');
});
